import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const IntroduceBtn = ({ text, isActive, onClick, addClass }) => {
  const { i18n, t } = useTranslation();

  useEffect(() => {}, []);

  return (
    <span
      className={`text-sm sm:text-lg md:text-xl hug:text-2xl cursor-pointer py-3 ${
        isActive ? 'active' : ''
      } ${addClass} `}
      onClick={onClick}
    >
      <em>{t(text)}</em>
    </span>
  );
};

export default IntroduceBtn;
